import React from "react";
import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const session = localStorage.getItem("sb_session");
  if (!session) return <Navigate to="/prijava" replace />;
  return children;
}
